import { ADD_NEW_COMMENT_REPLY, ADD_NEW_COMMENT, UPDATE_UPDOWNVOTE_TOTAL, DELETE_COMMENT_REPLY, EDIT_COMMENT_REPLY, EDIT_COMMENT, STORE_COMMENT} from '../constants/actionConstants';


// content -- current section we are reading
const CommentReducer =  (state = {dummy:false, comments:[]}, action) =>{
    // I do not know why we need this, but comments is set to "undefined" otherwise and this causes problems
    if(state.comments === undefined)
    {
        state.comments = [] ; 
    }

    switch(action.type)
    {
        case STORE_COMMENT:     
            console.log(action.payload)
            return {...state, comments: action.payload}

        // Change number of up/down votes
        case UPDATE_UPDOWNVOTE_TOTAL:
            const newComments_up = structuredClone(state.comments);
            const child_indices_up = action.payload.child_indices
            const comment_index_up =  newComments_up.map(e=>e._id).indexOf(action.payload.root_comment_id);
            switch(child_indices_up.length)
            {
                case 0:
                    newComments_up[comment_index_up].upvotes+=action.payload.increment
                    break;
                case 1:
                    newComments_up[comment_index_up].children[child_indices_up[0]].upvotes+=action.payload.increment
                    break;
                case 2:
                    newComments_up[comment_index_up].children[child_indices_up[0]].children[child_indices_up[1]].upvotes+=action.payload.increment
                    break;
                case 3:
                    newComments_up[comment_index_up].children[child_indices_up[0]].children[child_indices_up[1]].children[child_indices_up[2]].upvotes+=action.payload.increment
                    break;
                case 4:
                    newComments_up[comment_index_up].children[child_indices_up[0]].children[child_indices_up[1]].children[child_indices_up[2]].children[child_indices_up[3]].upvotes+=action.payload.increment
                    break;
                    
                default:
        
            }
            return {...state, comments: newComments_up }

        
        // Add a reply to a comment  {reply, content_id, comment_id, child_indices}
        case ADD_NEW_COMMENT_REPLY:
            const newComments_ancr = structuredClone(state.comments);
            const child_indices = action.payload.child_indices
            const comment_index =  newComments_ancr.map(e=>e._id).indexOf(action.payload.comment_id);
            switch(child_indices.length)
            {
                case 0:
                    newComments_ancr[comment_index].children.push(action.payload.reply)
                    break;
                case 1:
                    newComments_ancr[comment_index].children[child_indices[0]].children.push(action.payload.reply)
                    break;
                case 2:
                    newComments_ancr[comment_index].children[child_indices[0]].children[child_indices[1]].children.push(action.payload.reply)
                    break;
                case 3:
                    newComments_ancr[comment_index].children[child_indices[0]].children[child_indices[1]].children[child_indices[2]].children.push(action.payload.reply)
                    break;
                case 4:
                    // If we are already length 4, then stay length 4
                    newComments_ancr[comment_index].children[child_indices[0]].children[child_indices[1]].children[child_indices[2]].children.push(action.payload.reply)
                    break;
                default:   
            }
        return  {...state, comments:newComments_ancr}

        // Add a reply to a comment  {reply, content_id, comment_id, child_indices}
        case EDIT_COMMENT_REPLY:
            const newComments_ecr = structuredClone(state.comments);
            const child_indices_ecr = action.payload.child_indices
            const comment_index_ecr =  newComments_ecr.map(e=>e._id).indexOf(action.payload.comment_id);
            switch(child_indices_ecr.length)
            {
                case 0:
                    newComments_ecr[comment_index_ecr].contents= action.payload.edit_data.contents
                    newComments_ecr[comment_index_ecr].date= action.payload.edit_data.date
                    newComments_ecr[comment_index_ecr]["edited"]= true
                    break;
                case 1:
                    newComments_ecr[comment_index_ecr].children[child_indices_ecr[0]].contents= action.payload.edit_data.contents
                    newComments_ecr[comment_index_ecr].children[child_indices_ecr[0]].date= action.payload.edit_data.date
                    newComments_ecr[comment_index_ecr].children[child_indices_ecr[0]]["edited"]= true
                    break;
                case 2:
                    newComments_ecr[comment_index_ecr].children[child_indices_ecr[0]].children[child_indices_ecr[1]].contents= action.payload.edit_data.contents
                    newComments_ecr[comment_index_ecr].children[child_indices_ecr[0]].children[child_indices_ecr[1]].date= action.payload.edit_data.date
                    newComments_ecr[comment_index_ecr].children[child_indices_ecr[0]].children[child_indices_ecr[1]]["edited"]= true
                    break;
                case 3:
                    newComments_ecr[comment_index_ecr].children[child_indices_ecr[0]].children[child_indices_ecr[1]].children[child_indices_ecr[2]].contents= action.payload.edit_data.contents
                    newComments_ecr[comment_index_ecr].children[child_indices_ecr[0]].children[child_indices_ecr[1]].children[child_indices_ecr[2]].date= action.payload.edit_data.date
                    newComments_ecr[comment_index_ecr].children[child_indices_ecr[0]].children[child_indices_ecr[1]].children[child_indices_ecr[2]]["edited"]= true
                    break;
                case 4:
                    newComments_ecr[comment_index_ecr].children[child_indices_ecr[0]].children[child_indices_ecr[1]].children[child_indices_ecr[2]].children[child_indices_ecr[3]].contents= action.payload.edit_data.contents
                    newComments_ecr[comment_index_ecr].children[child_indices_ecr[0]].children[child_indices_ecr[1]].children[child_indices_ecr[2]].children[child_indices_ecr[3]].date= action.payload.edit_data.date
                    newComments_ecr[comment_index_ecr].children[child_indices_ecr[0]].children[child_indices_ecr[1]].children[child_indices_ecr[2]].children[child_indices_ecr[3]]["edited"]= true
                    break;
                default:   
            }
        return  {...state, comments:newComments_ecr}
        

        case DELETE_COMMENT_REPLY:
            const newComments_dcr = structuredClone(state.comments);
            const child_indices_dcr = action.payload.child_indices
            const comment_index_dcr =  newComments_dcr.map(e=>e._id).indexOf(action.payload.comment_id);
            switch(child_indices_dcr.length)
            {
                case 0:
                    newComments_dcr.splice(comment_index_dcr, 1)
                    break;
                case 1:
                    newComments_dcr[comment_index_dcr].children.splice(child_indices_dcr[0],1)
                    break;
                case 2:
                    newComments_dcr[comment_index_dcr].children[child_indices_dcr[0]].children.splice(child_indices_dcr[1],1)
                    break;
                case 3:
                    newComments_dcr[comment_index_dcr].children[child_indices_dcr[0]].children[child_indices_dcr[1]].children.splice(child_indices_dcr[2],1)
                    break;
                case 4:
                    // Deletes n'th value and all after it by directly setting length
                    newComments_dcr[comment_index_dcr].children[child_indices_dcr[0]].children[child_indices_dcr[1]].children[child_indices_dcr[2]].children.length=child_indices_dcr[3]
                    break;
                default:   
            }
            return  {...state, comments:newComments_dcr}
        

        // Add a new comment to the content structure
        case ADD_NEW_COMMENT:
            console.log("Adding comment")
            console.log(action.payload)
            // Update the comment
            return  {...state, comments:[...state.comments, action.payload.newComment]}

        // Edit top level comment
        case EDIT_COMMENT:
            // Copy the relevant content object
            let newComments_ec = structuredClone(state.comments) ; 
            // Find the index of the comment
            const comment_index_ec=  newComments_ec.map(e=>e._id).indexOf(action.payload.editedComment._id);
            // Add the new comment
            newComments_ec[comment_index_ec] = action.payload.editedComment
            // Update the comment
            return  {...state, comments:newComments_ec}
        default:
            return state ; 
    }
    
} ; 

export default CommentReducer ; 